import * as Yup from 'yup';
import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const baseYData = [
  { value: 'OFF', label: 'OFF_DUTY' },
  { value: 'SB', label: 'SLEEPER_BERTH' },
  { value: 'DR', label: 'DRIVING' },
  { value: 'ON', label: 'ON_DUTY' },
];

export const xData = [
  'M',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  'N',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  'M',
];

export const schema = Yup.object().shape({
  note: checkServiceProvider('config_noteValidation', window.$environment.SERVICE_PROVIDER, false)
    ? Yup.string().nullable().required(i18n.t('common.fieldRequiredMessage')).min(4, i18n.t('Please enter atleast 4 characters'))
    : '',
  comment: Yup.string()
    .nullable()
    .required(i18n.t('common.fieldRequiredMessage'))
    .min(4, i18n.t('Please enter atleast 4 characters')),
  distance: Yup.number().typeError(i18n.t('common.validNumberMessage')),
  driverId: Yup.number()
    .nullable()
    .required(i18n.t('Please fill in atleast one assigned driver.'))
    .test(
      'not-zero',
      i18n.t('Please fill in atleast one assigned driver.'),
      value => value !== 0 && value != null
    ),
});

export const dataFormMappings = [
  { name: 'driverUserId', field: 'driverId', log: 'driverId' },
  { name: 'driverName', field: 'driverName', log: 'driverName' },
  { name: 'codriver', field: 'codriverName', log: 'codriverName' },
  { name: 'carrier', field: 'carrierName', log: 'carrierName' },
  { name: 'vehicles', field: 'vehilceName', log: 'vehilceName' },
  { name: 'trailers', field: 'trailerName', log: 'trailerName' },
  { name: 'distance', field: 'distance', log: 'distance' },
  { name: 'from1', field: 'fromLocation', log: 'fromLocation' },
  { name: 'to1', field: 'toLocation', log: 'toLocation' },
  { name: 'main_address', field: 'mainOfficeLocation', log: 'mainOfficeLocation' },
  { name: 'home_address', field: 'terminal', log: 'terminal' },
  { name: 'ship_docs', field: 'shippingDocs', log: 'shippingDocs' },
  { name: 'notes', field: 'note', log: 'note' },
  { name: 'logSigningLocation', field: 'logSigningLocation', log: 'logSigningLocation' },
  { name: 'comments', field: 'comment', log: 'comment' },
];

export const headerMap = {
  true: 'Edit',
  false:'logs.editHeading',
};
